// phonics_data_lt18.js
// Letter Teams L18 - L18 Digraphs ng, nk
// 路由：/phonics/lt18

const MEDIA_BASE = '/media/phonics/lt18';
const V = 'v1';

export const letterDataLt18 = {
  id: 'lt18',
  letter: 'L18',
  title: 'L18 Digraphs ng, nk',
  mediaBase: MEDIA_BASE,

  part1Video: {
    src: `${MEDIA_BASE}/part1.mp4?${V}`,
  },

  part3Video: {
    src: `${MEDIA_BASE}/part3.mp4?${V}`,
  },

  reviewPic: {
    src: `${MEDIA_BASE}/review.png?${V}`,
  },

  storySections: [
    {
      label: 'Learn the story (1)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story1.mp4?${V}` }],
      lines: [
        { en: "It is spring.", audioEn: `${MEDIA_BASE}/story1_1.mp3?${V}` },
        { en: "The pals see Frank.", audioEn: `${MEDIA_BASE}/story1_2.mp3?${V}` },
        { en: "He sits on a swing.", audioEn: `${MEDIA_BASE}/story1_3.mp3?${V}` },
        { en: "The swing is pink.", audioEn: `${MEDIA_BASE}/story1_4.mp3?${V}` },
        { en: "Frank looks sad.", audioEn: `${MEDIA_BASE}/story1_5.mp3?${V}` },
        { en: "What can we do?", audioEn: `${MEDIA_BASE}/story1_6.mp3?${V}` },
        { en: "Let's think.", audioEn: `${MEDIA_BASE}/story1_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (2)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story2.mp4?${V}` }],
      lines: [
        { en: "Here is a ring.", audioEn: `${MEDIA_BASE}/story2_1.mp3?${V}` },
        { en: "Thank you.", audioEn: `${MEDIA_BASE}/story2_2.mp3?${V}` },
        { en: "But Frank does not smile.", audioEn: `${MEDIA_BASE}/story2_3.mp3?${V}` },
        { en: "The pals bring some tea.", audioEn: `${MEDIA_BASE}/story2_4.mp3?${V}` },
        { en: "Thank you.", audioEn: `${MEDIA_BASE}/story2_5.mp3?${V}` },
        { en: "Frank drinks the tea.", audioEn: `${MEDIA_BASE}/story2_6.mp3?${V}` },
        { en: "No smile.", audioEn: `${MEDIA_BASE}/story2_7.mp3?${V}` },
      ],
    },
    {
      label: 'Learn the story (3)',
      instructionAudio: `/media/phonics/lt01/audio_instruction_repeat_story.mp3`,
      titleCn: '跟读故事',
      videos: [{ src: `${MEDIA_BASE}/story3.mp4?${V}` }],
      lines: [
        { en: "Do you want to sing?", audioEn: `${MEDIA_BASE}/story3_1.mp3?${V}` },
        { en: "No.", audioEn: `${MEDIA_BASE}/story3_2.mp3?${V}` },
        { en: "I want to fly.", audioEn: `${MEDIA_BASE}/story3_3.mp3?${V}` },
        { en: "I think we can help.", audioEn: `${MEDIA_BASE}/story3_4.mp3?${V}` },
        { en: "You need wings.", audioEn: `${MEDIA_BASE}/story3_5.mp3?${V}` },
        { en: "Yay! I can fly!", audioEn: `${MEDIA_BASE}/story3_6.mp3?${V}` },
        { en: "Thank you for the wings!", audioEn: `${MEDIA_BASE}/story3_7.mp3?${V}` },
      ],
    },
  ],
};
